import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface PutWordCategoryRequest {
    word_idx: number[];
    event_category_idx: number;
}
export const usePutWordCategory = (successCallback?: () => void): UseMutationResult<null, Error, PutWordCategoryRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, PutWordCategoryRequest>({
        mutationFn: async (putData: PutWordCategoryRequest) => {
            const response = await axios.put(`${enum_api_uri.put_word_category}`, putData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        onSuccess: (_, { word_idx }) => {
            queryClient.invalidateQueries({ queryKey: ["getWordList"] });
            word_idx.forEach(id => {
                queryClient.invalidateQueries({ queryKey: ["getWordInfo", id] });
            });
            successCallback?.();
        },
    });
};
